import React from 'react'
import SearchIcon from '@mui/icons-material/Search'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import { dialogSearchIconSx } from '../../../constants/dialogSx'

export default function RbacUserSearchField({ value, onChange, placeholder, sx }) {
  return (
    <TextField
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      size="small"
      fullWidth
      hiddenLabel
      InputLabelProps={{ shrink: false }}
      sx={sx}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ mr: 0.5 }}>
            <SearchIcon sx={dialogSearchIconSx} />
          </InputAdornment>
        )
      }}
    />
  )
}
